import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Parent Dashboard is parents/guardians ONLY. Teens are bounced back
// to their own dashboard.
const ParentRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'parent' && user.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default ParentRoute;
